import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { LegalPartner } from '@egw/features-documents'

export const LegalPartnerPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.documents.title')} />
      <LegalPartner />
    </Layout>
  )
}
